module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/buildingwithblocks-e5ba92b655e849b18048f486bd6032d3.png";